import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../../ChallengeAdmin'
import { CustomTypeCategory, customUnits } from '../../../../../services/CustomTypes'
import YumSelect from '../../../../../components/YumSelect/YumSelect'
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage'
import { ReactComponent as UnitInactiveIcon } from '../../../../../assets/v3/icons/unit-inactive.svg'
import { getFieldName, getErrorMessage } from '../goalFormHelpers'

interface CustomUnitFieldProps {
  control: Control<FormData>
  fieldPrefix: string
  activityType: CustomTypeCategory
  formStep: number
  validationRules: {
    min?: number
    max?: number
    required?: boolean
  }
}

/**
 * Custom unit select field for defined activities.
 * Shows a dropdown with available units for the activity type.
 */
export default function CustomUnitField({
  control,
  fieldPrefix,
  activityType,
  formStep,
  validationRules,
}: CustomUnitFieldProps) {
  // Only show if there are multiple units for this activity type
  const hasMultipleUnits = customUnits.filter((unit) => unit.category === activityType)?.length > 1

  if (!hasMultipleUnits) {
    return null
  }

  return (
    <Controller
      name={getFieldName('customType', fieldPrefix) as any}
      rules={validationRules}
      control={control}
      render={({ field: { ref, ...otherField }, fieldState: { error } }) => (
        <>
          {/* @ts-ignore */}
          <YumSelect
            label={t`Unit`}
            startIcon={UnitInactiveIcon}
            error={!!error}
            {...otherField}
            style={{ marginBottom: 0 }}
          >
            {customUnits.map(
              (unit, keyIndex) =>
                unit.category === activityType && (
                  <option key={keyIndex} value={unit.id}>
                    {unit.label}
                  </option>
                ),
            )}
          </YumSelect>
          {error && getErrorMessage(error) && <ErrorMessage>{getErrorMessage(error)}</ErrorMessage>}
        </>
      )}
    />
  )
}
